import React from 'react';
import PropTypes from 'prop-types';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import SubstanceHeader from '@Components/Results/substances/details/SubstanceHeader';
import SubstanceSupplierData from '@Components/Results/substances/details/substance-supplier-data.component';
import { createE2EClass } from '@Utils/String';

import './SubstanceDetailsContainer.scss';

const SubstanceDetailsContainer = React.memo(({ metadata, substance, database }) => {
  const { supportsSupplierData } = database;
  const shouldRenderSupplierData = !metadata?.heatmapMode && supportsSupplierData && substance.supplierData;

  return (
    <div className="substance-details-container">
      <SubstanceHeader metadata={metadata} substance={substance} database={database} />

      {shouldRenderSupplierData && (
        <div className={`substance-details substance-details--${createE2EClass(database.name)}`}>
          <div className="substance-details-right els-btn-group-vertical">
            <SubstanceSupplierData supplierData={substance.supplierData} database={database} />
          </div>
        </div>
      )}
    </div>
  );
});

SubstanceDetailsContainer.propTypes = {
  metadata: MetadataPropTypesShape,
  substance: PropTypes.object.isRequired,
  database: PropTypes.object.isRequired,
};

SubstanceDetailsContainer.displayName = 'SubstanceDetailsContainer';

export default SubstanceDetailsContainer;
